import { render, staticRenderFns } from "./remodelDetail.vue?vue&type=template&id=b416e066&scoped=true&"
import script from "./remodelDetail.vue?vue&type=script&lang=js&"
export * from "./remodelDetail.vue?vue&type=script&lang=js&"
import style0 from "./remodelDetail.vue?vue&type=style&index=0&id=b416e066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b416e066",
  null
  
)

export default component.exports